import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../styles/design-system.css';

function OAuthResult() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const brandId    = searchParams.get('brand_id');
    const socialSuccess = searchParams.get('social_success') || '';
    const socialError   = searchParams.get('social_error')   || '';

    if (brandId) {
      const query = new URLSearchParams();
      if (socialSuccess) query.set('social_success', socialSuccess);
      if (socialError)   query.set('social_error',   socialError);
      const suffix = query.toString() ? `?${query.toString()}` : '';
      navigate(`/brand/${brandId}/settings${suffix}`, { replace: true });
      return;
    }

    if (socialError) {
      navigate(`/dashboard?error=${encodeURIComponent(socialError)}`, { replace: true });
      return;
    }

    navigate('/dashboard', { replace: true });
  }, [navigate, searchParams]);

  return (
    <div className="ps-loading">
      <div className="ps-spinner" />
      <span className="ps-loading-text">Finishing social account connection…</span>
    </div>
  );
}

export default OAuthResult;
